import React from "react";

import { Box, BoxProps } from "@mui/material";

export interface IgDotProps extends Omit<BoxProps, "children" | "color"> {
  color?: string;
  size?: number | string;
}

export const IgDot = ({
  color = "currentColor",
  component = "span",
  size = 8,
  sx,
  ...rest
}: IgDotProps) => {
  const sxOverrides = Array.isArray(sx) ? sx : [sx];

  return (
    <Box
      aria-hidden="true"
      component={component}
      {...rest}
      sx={[
        {
          backgroundColor: color,
          borderRadius: "50%",
          display: "inline-block",
          flex: "0 0 auto",
          height: size,
          width: size,
        },
        ...sxOverrides,
      ]}
    />
  );
};
